const ONBOARDING_STEP_KEY = "onboardingStep";
const ONBOARDING_COMPLETE_KEY = "onboardingComplete";

export const setOnboardingStep = (step) => {
  localStorage.setItem(ONBOARDING_STEP_KEY, String(step));
};

export const getOnboardingStep = () => {
  const step = parseInt(localStorage.getItem(ONBOARDING_STEP_KEY), 10);
  return Number.isNaN(step) ? 2 : step;
};

export const setOnboardingComplete = () => {
  localStorage.setItem(ONBOARDING_COMPLETE_KEY, "true");
};

export const isOnboardingComplete = () => {
  return localStorage.getItem(ONBOARDING_COMPLETE_KEY) === "true";
};

export const clearOnboardingState = () => {
  localStorage.removeItem(ONBOARDING_STEP_KEY);
  localStorage.removeItem(ONBOARDING_COMPLETE_KEY);
};

/**
 * loginWithToken
 *
 * Call this after ANY API that returns a token + user object
 * (e.g. login, step1-signup onboarding).
 *
 * Expected `data` shape:
 * {
 *   token: "...",
 *   user: { id, role, is_suspended },
 *   next_step?: number   // optional, returned by onboarding APIs
 * }
 */
export const loginWithToken = (data, navigate) => {
  const { token, user, next_step } = data;

  // Always wipe ALL previous session data before writing new credentials.
  // This prevents stale tokens/roles from a previous company's session.
  localStorage.removeItem("token");
  localStorage.removeItem("role");
  localStorage.removeItem("userId");
  clearOnboardingState();

  localStorage.setItem("token", token);
  localStorage.setItem("role", user?.role ?? "");
  localStorage.setItem("userId", user?.id ?? "");

  const role = user?.role;
  const parsedNextStep = next_step != null ? parseInt(next_step, 10) : null;

  if (role === "Admin") {
    navigate("/onboarding");
  } else if (role === "SuperAdmin") {
    navigate("/worklist/clientonboarding");
  } else if (role === "Client") {
    if (parsedNextStep != null && !Number.isNaN(parsedNextStep)) {
      setOnboardingStep(parsedNextStep);
    } else {
      setOnboardingStep(2);
    }
    navigate("/onboarding");
  } else {
    navigate("/");
  }
};
